import request from '@/utils/request'

// 采购人黑名单（功能二）
export function getBlacklist (params) {
  return request({ url: '/xtgl/blacklist/getBlacklist', method: 'get', params })
}

export function addBlacklist (data) {
  return request({ url: '/xtgl/blacklist/addBlacklist', method: 'post', data })
}

export function updateBlacklist (data) {
  return request({ url: '/xtgl/blacklist/updateBlacklist', method: 'post', data })
}

export function removeBlacklist (data) {
  return request({ url: '/xtgl/blacklist/removeBlacklist', method: 'post', data })
}

export function importBlacklist (data) {
  return request({ url: '/xtgl/blacklist/importBlacklist', method: 'post', data })
}
